<template>
  <router-view />
</template>

<script>
export default {
  name: "ScheduleBase",
};
</script>

<style></style>
